import { pick } from 'lodash-es'

const transformToCreateBrandInput = values => pick(values, 'name', 'website')

export default transformToCreateBrandInput
